import React, { useState } from 'react';
import { MdClose, MdPerson, MdEmail, MdPhone, MdBusiness, MdSecurity } from 'react-icons/md';
import SearchableDropdown from './SearchableDropdown';

const AddUserModal = ({ 
  isOpen, 
  onClose, 
  showPopup, 
  fetchData, 
  API_BASE_URL, 
  roles, 
  mmdas,
  API_CONFIG 
}) => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    role_id: '',
    mmda_id: null,
    status: 'active'
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }

    // If Super Admin is selected, set MMDA to null
    if (name === 'role_id') {
      const selectedRoleObj = roles.find(role => String(role.role_id) === value);
      if (selectedRoleObj && (selectedRoleObj.role_name === 'super_admin' || selectedRoleObj.name === 'Super Admin')) {
        setFormData(prev => ({ ...prev, mmda_id: null }));
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.role_id) {
      newErrors.role_id = 'Role selection is required';
    }

    if (!formData.full_name.trim()) {
      newErrors.full_name = 'Full name is required';
    } else if (formData.full_name.trim().length < 2) {
      newErrors.full_name = 'Full name must be at least 2 characters';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^[0-9+\-\s()]{10,}$/.test(formData.phone.trim())) {
      newErrors.phone = 'Please enter a valid phone number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const selectedRoleObj = roles.find(role => String(role.role_id) === formData.role_id);
      const isSuperAdmin = selectedRoleObj && (selectedRoleObj.role_name === 'super_admin' || selectedRoleObj.name === 'Super Admin');

      const newUserData = {
        full_name: formData.full_name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        status: formData.status,
        role_id: formData.role_id,
        mmda_id: isSuperAdmin ? null : formData.mmda_id,
        password: 'zxcv123$$',
      };

      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...API_CONFIG.headers,
        },
        body: JSON.stringify(newUserData),
      });

      if (!response.ok) {
        throw new Error('Failed to create user');
      }

      showPopup('User added successfully!', 'success');
      fetchData();
      handleClose();
    } catch (error) {
      console.error('Failed to add user:', error);
      showPopup('Failed to add user. Please try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setFormData({
      full_name: '',
      email: '',
      phone: '',
      role_id: '',
      mmda_id: null,
      status: 'active'
    });
    setErrors({});
    setIsSubmitting(false);
    onClose();
  };

  const selectedRoleObj = roles.find(role => String(role.role_id) === formData.role_id);
  const isSuperAdmin = selectedRoleObj && (selectedRoleObj.role_name === 'super_admin' || selectedRoleObj.name === 'Super Admin');

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    }} onClick={handleClose}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: 16,
        padding: 0,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        transform: 'scale(1)',
        transition: 'all 0.3s ease'
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '24px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdPerson size={28} />
            <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600' }}>Add New User</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              borderRadius: 8,
              padding: 8,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
          >
            <MdClose size={20} color="white" />
          </button>
        </div>

        {/* Form Content */}
        <form onSubmit={handleSubmit} style={{ padding: '32px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>

            {/* Role Field */}
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                <MdSecurity size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Role *
              </label>
              <select
                name="role_id"
                value={formData.role_id}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: errors.role_id ? '2px solid #ef4444' : '2px solid #e5e7eb',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  backgroundColor: '#fafafa',
                  cursor: 'pointer'
                }}
                onFocus={e => {
                  if (!errors.role_id) {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }
                }}
                onBlur={e => {
                  if (!errors.role_id) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fafafa';
                  }
                }}
              >
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role.role_id} value={role.role_id}>
                    {role.role_name?.replace(/_/g, ' ')?.replace(/\b\w/g, char => char.toUpperCase()) || role.name}
                  </option>
                ))}
              </select>
              {errors.role_id && (
                <p style={{ color: '#ef4444', fontSize: 12, margin: '4px 0 0 0' }}>
                  {errors.role_id}
                </p>
              )}
            </div>

            {/* Full Name Field */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                <MdPerson size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Full Name *
              </label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleInputChange}
                placeholder="Enter full name"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: errors.full_name ? '2px solid #ef4444' : '2px solid #e5e7eb',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  backgroundColor: '#fafafa'
                }}
                onFocus={e => {
                  if (!errors.full_name) {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }
                }}
                onBlur={e => {
                  if (!errors.full_name) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fafafa';
                  }
                }}
              />
              {errors.full_name && (
                <p style={{ color: '#ef4444', fontSize: 12, margin: '4px 0 0 0' }}>
                  {errors.full_name}
                </p>
              )}
            </div>

            {/* Status Field */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                Status
              </label>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '2px solid #e5e7eb',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  backgroundColor: '#fafafa',
                  cursor: 'pointer'
                }}
                onFocus={e => {
                  e.currentTarget.style.borderColor = '#667eea';
                  e.currentTarget.style.backgroundColor = '#ffffff';
                }}
                onBlur={e => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.backgroundColor = '#fafafa';
                }}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            {/* Email Field */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                <MdEmail size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter email address"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: errors.email ? '2px solid #ef4444' : '2px solid #e5e7eb',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  backgroundColor: '#fafafa'
                }}
                onFocus={e => {
                  if (!errors.email) {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }
                }}
                onBlur={e => {
                  if (!errors.email) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fafafa';
                  }
                }}
              />
              {errors.email && (
                <p style={{ color: '#ef4444', fontSize: 12, margin: '4px 0 0 0' }}>
                  {errors.email}
                </p>
              )}
            </div>

            {/* Phone Field */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                <MdPhone size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Phone Number *
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter phone number"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: errors.phone ? '2px solid #ef4444' : '2px solid #e5e7eb',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  backgroundColor: '#fafafa'
                }}
                onFocus={e => {
                  if (!errors.phone) {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.backgroundColor = '#ffffff';
                  }
                }}
                onBlur={e => {
                  if (!errors.phone) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fafafa';
                  }
                }}
              />
              {errors.phone && (
                <p style={{ color: '#ef4444', fontSize: 12, margin: '4px 0 0 0' }}>
                  {errors.phone}
                </p>
              )}
            </div>

            {/* MMDA Field */}
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: '600',
                color: '#374151',
                fontSize: 14
              }}>
                <MdBusiness size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                MMDA {!isSuperAdmin && '*'}
              </label>
              <div style={{ position: 'relative' }}>
                <SearchableDropdown
                  options={mmdas.map((mmda) => ({
                    value: mmda.mmda_id,
                    label: mmda.name,
                  }))}
                  value={formData.mmda_id}
                  onChange={(value) => setFormData(prev => ({ ...prev, mmda_id: value }))}
                  placeholder={isSuperAdmin ? "Not applicable for Super Admin" : "Select MMDA"}
                  isDisabled={isSuperAdmin}
                />
              </div>
              {isSuperAdmin && (
                <p style={{ color: '#6b7280', fontSize: 12, margin: '4px 0 0 0' }}>
                  Super Admin users are not assigned to any specific MMDA
                </p>
              )}
            </div>

            {/* Password Information */}
            <div style={{
              gridColumn: '1 / -1',
              backgroundColor: '#fff3e0',
              padding: 16,
              borderRadius: 8,
              border: '1px solid #ffcc02',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdSecurity size={20} style={{ color: '#f57c00' }} />
                <label style={{ fontSize: 14, color: '#f57c00', fontWeight: 'bold' }}>Default Password</label>
              </div>
              <p style={{ margin: 0, fontSize: 16, color: '#f57c00', fontWeight: 'bold', fontFamily: 'monospace' }}>
                zxcv123$$
              </p>
              <p style={{ margin: '8px 0 0 0', fontSize: 12, color: '#f57c00' }}>
                All users are created with this default password. They can change it after first login.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 12,
            marginTop: 32,
            paddingTop: 24,
            borderTop: '1px solid #e5e7eb'
          }}>
            <button
              type="button"
              onClick={handleClose}
              disabled={isSubmitting}
              style={{
                padding: '12px 24px',
                border: '2px solid #e5e7eb',
                borderRadius: 8,
                backgroundColor: '#ffffff',
                color: '#374151',
                fontSize: 14,
                fontWeight: '600',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: isSubmitting ? 0.6 : 1
              }}
              onMouseEnter={e => {
                if (!isSubmitting) {
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                  e.currentTarget.style.borderColor = '#d1d5db';
                }
              }}
              onMouseLeave={e => {
                if (!isSubmitting) {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.borderColor = '#e5e7eb';
                }
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                padding: '12px 24px',
                border: 'none',
                borderRadius: 8,
                background: isSubmitting
                  ? '#9ca3af'
                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                fontSize: 14,
                fontWeight: '600',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}
              onMouseEnter={e => {
                if (!isSubmitting) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.4)';
                }
              }}
              onMouseLeave={e => {
                if (!isSubmitting) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }
              }}
            >
              <MdPerson size={16} />
              {isSubmitting ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
